import { fetchApi } from '@/config/axiosSetting';

import {
  IBodyExpertEntryTabsQueryResponseType,
  IBodyExpertEntryTabsTypeParams,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyExpertTabs/getBodyExpertTabsQuery.type';

export const getBodyExpertTabsQueryFunction = (
  params: IBodyExpertEntryTabsTypeParams,
): Promise<IBodyExpertEntryTabsQueryResponseType[]> => {
  return fetchApi.get(`body/reports/${params.id}/adjusting/entry_tabs/`);
};
